module.exports = __webpack_public_path__ + "a8a6258529a5136b1a42b63c2a5052a5.fbx";